export const opportunityActionTypes = {
    'SET_RFP_DATA': 'SET_RFP_DATA',
    'SET_PROPOSAL_DATA':'SET_PROPOSAL_DATA',
    'SET_MYPROJECT':'SET_MYPROJECT',
    "SET_REMINDER_ASSETID":"SET_REMINDER_ASSETID"
}